import { makeObservable, observable, action } from 'mobx';

type Variant = 'default' | 'success' | 'warning' | 'error';

class UIStore {
  notification: { message: string; variant: Variant } = { message: '', variant: 'default' };
  openedConfirmationDialogs: { [name: string]: boolean } = {};
  confParams: { [name: string]: any } = {};

  constructor() {
    makeObservable(this, {
      notification: observable,
      openedConfirmationDialogs: observable,
      confParams: observable,
      setNotificationMessage: action,
      openConfirmationDialog: action,
      closeConfirmationDialog: action
    });
  }

  setNotificationMessage = (message: string, variant: Variant = 'default') => {
    this.notification = { message, variant };
  };

  openConfirmationDialog = (dialogName: string, params: object = {}) => {
    this.confParams = { ...params };
    this.openedConfirmationDialogs = { ...this.openedConfirmationDialogs, [dialogName]: true };
  };

  closeConfirmationDialog = (dialogName: string) => {
    this.openedConfirmationDialogs = { ...this.openedConfirmationDialogs, [dialogName]: false };
  };
}
const singleton = new UIStore();
export default singleton;
